import { useState } from 'react';
import { useQueryBuilderStore } from '@features/query-builder/store';

export function useFiltersPanelVisibility(entityName: string, useQueryBuilder: boolean) {
  const [isLegacyVisible, setIsLegacyVisible] = useState(false);
  const isQbPanelOpen = useQueryBuilderStore((s) =>
    useQueryBuilder ? (s.panelOpenByEntity[entityName] ?? false) : false,
  );

  const isVisible = useQueryBuilder ? isQbPanelOpen : isLegacyVisible;

  const toggle = () => {
    if (useQueryBuilder) {
      useQueryBuilderStore.getState().setPanelOpen(entityName, !isQbPanelOpen);
    } else {
      setIsLegacyVisible((visible) => !visible);
    }
  };

  return { isVisible, toggle };
}
